import React from "react";

const AboutUsMissionSection = () =>{
    return(
        <>
          <div class="solution sp bg1">
          <div class="container">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="heading1">
                  <span class="span"><img src="/assets/img/icons/span1.png" alt=""/> Our Mission</span>
                  <h2>Innovating for Success: Our Technology Mission</h2>
                  <div class="space16"></div>
                  <p>Our mission is to simplify and empower global financial transactions by offering accurate, secure, and fast currency exchange data through robust APIs. We aim to bridge the gap between traditional forex systems and modern digital platforms, enabling businesses of all sizes to access reliable forex data without complexities or high costs.
                  </p>
                  {/* <div class="space16"></div> */}
                  {/* <p>"At TechXen, our mission is to empower businesses through technology. We believe in harnessing the power of innovation to drive growth, efficiency, and sustainability for our clients. Through our tailored technology solutions and unwavering commitment to excellence, we strive to be the catalyst for positive change in the digital landscape.</p> */}

                  <div class="space30"></div>
                </div>
              </div>

              <div class="col-lg-6">
                <div class="solution-images">
                  
                  <div class="image2">
                    <img src="/assets/img/others/solution-img2.png" alt=""/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </>
    )
}

export default AboutUsMissionSection;